import { useNavigate } from "react-router-dom";
import qs from "qs";
import QueryString from "qs";

export const useAddQueryParams = () => {
	const navigate = useNavigate();

	return (params: QueryString.ParsedQs) => navigate(`?${qs.stringify({ ...params })}`);
};
